var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { fromSize } from '../../utilities/media';
export var StyleTabs = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > .rc-tabs > .rc-tabs-bar .rc-tabs-tab {\n    font-family: ", ";\n    font-size: 18px;\n    font-weight: 600;\n    padding: 16px 24px !important;\n    text-align: center;\n    line-height: 23px;\n    flex: 1;\n    color: ", ";\n\n    ", " {\n      border-bottom: 4px solid transparent;\n      margin-right: 0;\n\n      &:hover {\n        color: ", ";\n        border-color: ", ";\n      }\n    }\n  }\n  & > .rc-tabs-top {\n    border-bottom: none;\n  }\n  & > .rc-tabs-top .rc-tabs-bar {\n    border-bottom: 1px solid\n      ", ";\n  }\n  & > .rc-tabs > .rc-tabs-content > .rc-tabs-tabpane {\n    padding: 16px 0;\n  }\n  & .rc-tabs-ink-bar {\n    background-color: ", ";\n    height: 4px !important;\n  }\n  & > .rc-tabs > .rc-tabs-bar .rc-tabs-tab-active {\n    color: ", ";\n  }\n  ", "\n"], ["\n  & > .rc-tabs > .rc-tabs-bar .rc-tabs-tab {\n    font-family: ", ";\n    font-size: 18px;\n    font-weight: 600;\n    padding: 16px 24px !important;\n    text-align: center;\n    line-height: 23px;\n    flex: 1;\n    color: ", ";\n\n    ", " {\n      border-bottom: 4px solid transparent;\n      margin-right: 0;\n\n      &:hover {\n        color: ", ";\n        border-color: ", ";\n      }\n    }\n  }\n  & > .rc-tabs-top {\n    border-bottom: none;\n  }\n  & > .rc-tabs-top .rc-tabs-bar {\n    border-bottom: 1px solid\n      ", ";\n  }\n  & > .rc-tabs > .rc-tabs-content > .rc-tabs-tabpane {\n    padding: 16px 0;\n  }\n  & .rc-tabs-ink-bar {\n    background-color: ", ";\n    height: 4px !important;\n  }\n  & > .rc-tabs > .rc-tabs-bar .rc-tabs-tab-active {\n    color: ", ";\n  }\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.title;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.text.label.light;
}, fromSize('md'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.base.secondary.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.base.secondary.light;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.interface.neutral.light;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.base.secondary.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.base.secondary.regular;
}, function (_a) {
  var stretch = _a.stretch;
  return stretch ? "& > .rc-tabs-top .rc-tabs-nav-scroll {\n    width: 100%;\n    & .rc-tabs-nav {\n      width: 100%;\n      & > div {\n        display: flex;\n      }\n    }\n  }" : "";
});
var templateObject_1;